import { wsService } from "./wsService";

const section = "storage-rules";

function filter(param = {}) {
  return wsService.make_post_request(section + "/list", param);
}

function create(param = {}) {
  return wsService.make_post_request(section + "/create", param);
}

function update(param = {}) {
  return wsService.make_put_request(section + "/update", param);
}

function remove(param = {}) {
  return wsService.make_delete_request(section + "/delete", param);
}

function getConditionTypes() {
  return wsService.make_get_request(section + "/condition-types");
}

function getOperators() {
  return wsService.make_get_request(section + "/operators");
}

export const storageRuleService = {
  filter,
  create,
  update,
  remove,
  getConditionTypes,
  getOperators,
};
